<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<v-list>
    
		<template v-for="(evaluation, index) in project.substantiveEvaluations">
			<v-list-tile avatar :key="'substantive-evaluation-' + evaluation.id">
				<v-list-tile-avatar>
					<v-icon color="orange">event_seat</v-icon>
				</v-list-tile-avatar>
				<v-list-tile-content>
					<v-list-tile-title v-html="evaluation.teamUser.user.user.name + ' ' +
						evaluation.teamUser.user.user.surname"></v-list-tile-title>
					<v-list-tile-sub-title>Opinia merytoryczna</v-list-tile-sub-title>
					<span>
						<v-list-tile-action-text
							v-html="getSubstantiveEvaluationStatusText(evaluation)"></v-list-tile-action-text>
						<span v-if="evaluation.agencySubstantiveEvaluationStatus === 'REVISION'" class="ml-1">
							<v-tooltip top>
								<template v-slot:activator="{ on }">
									<v-icon size="16" color="blue" dark v-on="on">info_outline</v-icon>
								</template>
								<span>{{evaluation.detailedCorrectionCause}}</span>
							</v-tooltip>
						</span>
						<span class="ml-1" v-else-if="evaluation.agencySubstantiveEvaluationStatus === 'FINISHED'">
							<template v-if="evaluation.booleanEvaluation">
								<v-list-tile-action-text v-if="evaluation.recommending === true"
									style="color: green; font-weight: bold" v-html="'(Pozytywna)'"/>
								<v-list-tile-action-text v-else
									style="color: red; font-weight: bold" v-html="'(Negatywna)'"/>
							</template>
							<template v-else-if="evaluation.evaluationPointsSum !== null">
								<v-list-tile-action-text style="color: blue; font-weight: bold"
									v-html="'(' + evaluation.evaluationPointsSum + ' p.)'"/>
							</template>
						</span>
					</span>
				</v-list-tile-content>
				<v-list-tile-action>
					<egranty-icon-button icon="build"
						color="primary"
						label="Oddaj do poprawek"
						:disabled="!evaluationOpen"
						for="agency-project-evaluation-sublist-give-correction"
						id="agency-project-evaluation-sublist-give-correction"
						v-if="evaluation.agencySubstantiveEvaluationStatus === 'FINISHED'"
						@click="correctEvaluation('substantive', evaluation)"/>
				</v-list-tile-action>
				<v-list-tile-action>
					<egranty-icon-button icon="search"
						color="primary"
						label="Zobacz ocenę"
						for="agency-project-evaluation-sublist-see-rate"
						id="agency-project-evaluation-sublist-see-rate"
						v-if="evaluation.agencySubstantiveEvaluationStatus === 'FINISHED'"
						@click="viewEvaluation('substantive', evaluation)"/>
				</v-list-tile-action>
				<v-list-tile-action>
					<egranty-icon-button icon="delete"
						color="lightred"
						label="Usuń ocenę"
						for="agency-project-evaluation-sublist-delete-rate"
						id="agency-project-evaluation-sublist-delete-rate"
						:disabled="evaluationManagementDisabled() || project.agencyProjectStatus !== 'SUBMITTED'"
						@click="deleteSubstantiveEvaluation(project, evaluation.id, index)"/>
				</v-list-tile-action>
			</v-list-tile>
		</template>

		<template v-for="(evaluation, index) in project.expertEvaluations">
			<v-list-tile avatar :key="'expert-evaluation-' + evaluation.id">
				<v-list-tile-avatar>
					<v-icon color="orange">school</v-icon>
				</v-list-tile-avatar>
				<v-list-tile-content>
					<v-list-tile-title v-html="evaluation.agencyContestUser.user.name + ' ' +
						evaluation.agencyContestUser.user.surname"></v-list-tile-title>
					<v-list-tile-sub-title>Opinia eksperta</v-list-tile-sub-title>
					<span>
						<v-list-tile-action-text
							v-html="getExpertEvaluationStatusText(evaluation)"></v-list-tile-action-text>
						<span v-if="evaluation.agencyExpertEvaluationStatus === 'REVISION'" class="ml-1">
							<v-tooltip top>
								<template v-slot:activator="{ on }">
									<v-icon size="16" color="blue" dark v-on="on">info_outline</v-icon>
								</template>
								<span>{{evaluation.detailedCorrectionCause}}</span>
							</v-tooltip>
						</span>
						<span v-else-if="evaluation.agencyExpertEvaluationStatus === 'FINISHED'" class="ml-1">
							<v-list-tile-action-text v-if="evaluation.recommending === true"
								style="color: green; font-weight: bold" v-html="'(Pozytywna)'"/>
							<v-list-tile-action-text v-else
								style="color: red; font-weight: bold" v-html="'(Negatywna)'"/>
						</span>
					</span>
				</v-list-tile-content>
				<v-list-tile-action>
					<egranty-icon-button
						icon="build"
						color="primary"
						label="Oddaj do poprawek"
						for="agency-project-evaluation-sublist-give-correction3"
						id="agency-project-evaluation-sublist-give-correction3"
						:disabled="!evaluationOpen"
						v-if="evaluation.agencyExpertEvaluationStatus === 'FINISHED'"
						@click="correctEvaluation('expert', evaluation)"/>
				</v-list-tile-action>
				<v-list-tile-action>
					<egranty-icon-button
						icon="search"
						color="primary"
						label="Zobacz ocenę"
						for="agency-project-evaluation-sublist-see-rate3"
						id="agency-project-evaluation-sublist-see-rate3"
						v-if="evaluation.agencyExpertEvaluationStatus === 'FINISHED'"
						@click="viewEvaluation('expert', evaluation)"/>
				</v-list-tile-action>
				<v-list-tile-action>
					<egranty-icon-button
						icon="delete"
						color="lightred"
						label="Usuń ocenę"
						for="agency-project-evaluation-sublist-delete-rate3"
						id="agency-project-evaluation-sublist-delete-rate3"
						:disabled="evaluationManagementDisabled() || project.agencyProjectStatus !== 'SUBMITTED'"
						@click="deleteExpertEvaluation(project, evaluation.id, index)"/>
				</v-list-tile-action>
			</v-list-tile>
		</template>

		<template v-if="project.finalEvaluation">
			<v-list-tile avatar>
				<v-list-tile-avatar>
					<v-icon color="primary">event_seat</v-icon>
				</v-list-tile-avatar>
				<v-list-tile-content>
					<v-list-tile-title v-html="project.finalEvaluation.teamUser.user.user.name + ' ' +
						project.finalEvaluation.teamUser.user.user.surname"></v-list-tile-title>
					<v-list-tile-sub-title>Opinia końcowa</v-list-tile-sub-title>
					<span>
						<v-list-tile-action-text
							v-html="getFinalEvaluationStatusText(project.finalEvaluation)"></v-list-tile-action-text>
						<span v-if="project.finalEvaluation.agencyFinalEvaluationStatus === 'REVISION'" class="ml-1">
							<v-tooltip top>
								<template v-slot:activator="{ on }">
									<v-icon size="16" color="blue" dark v-on="on">info_outline</v-icon>
								</template>
								<span>{{project.finalEvaluation.detailedCorrectionCause}}</span>
							</v-tooltip>
						</span>
						<span v-if="project.finalEvaluation.agencyFinalEvaluationStatus === 'FINISHED'" class="ml-1">
							<v-list-tile-action-text v-if="project.finalEvaluation.recommending === true"
								style="color: green; font-weight: bold" v-html="'(Pozytywna)'"/>
							<v-list-tile-action-text v-else
								style="color: red; font-weight: bold" v-html="'(Negatywna)'"/>
						</span>
					</span>
				</v-list-tile-content>
				<v-list-tile-action>
					<egranty-icon-button
						icon="build"
						color="primary"
						label="Oddaj do poprawek"
						:disabled="!evaluationOpen"
						for="agency-project-evaluation-sublist-give-correction2"
						id="agency-project-evaluation-sublist-give-correction2"
						v-if="project.finalEvaluation.agencyFinalEvaluationStatus === 'FINISHED'"
						@click="correctEvaluation('final', project.finalEvaluation)"/>
				</v-list-tile-action>
				<v-list-tile-action>
					<egranty-icon-button
						icon="search"
						color="primary"
						label="Zobacz ocenę"
						for="agency-project-evaluation-sublist-see-rate2"
						id="agency-project-evaluation-sublist-see-rate2"
						v-if="project.finalEvaluation.agencyFinalEvaluationStatus === 'FINISHED'"
						@click="viewEvaluation('final', project.finalEvaluation)"/>
				</v-list-tile-action>
				<v-list-tile-action>
					<egranty-icon-button
						icon="delete"
						color="lightred"
						label="Usuń ocenę"
						for="agency-project-evaluation-sublist-delete-rate2"
						id="agency-project-evaluation-sublist-delete-rate2"
						:disabled="evaluationManagementDisabled() || project.agencyProjectStatus !== 'SUBMITTED'"
						@click="deleteFinalEvaluation(project)"/>
				</v-list-tile-action>
			</v-list-tile>
		</template>

		<v-dialog v-model="correctionData.dialog" persistent max-width="1000px">
			<v-card>
				<v-card-title>
					<span class="headline">Przekazanie oceny do poprawek</span>
				</v-card-title>
				<v-card-text>
					<v-text-field
						browser-autocomplete="off"
						data-vv-name="correctionCause"
						data-vv-as="Powód przekazania do poprawek"
						label="Powód przekazania do poprawek"
						aria-label="correction cause"
						for="agency-project-evaluation-sublist-reason-give-correction"
						id="agency-project-evaluation-sublist-reason-give-correction"
						:error-messages="vErrors.collect('correctionCause')"
						v-validate="'required'"
						@keydown="onKeyDownEvent"
						v-model="correctionCause">
					</v-text-field>
					<v-textarea
						browser-autocomplete="off"
						data-vv-name="detailedCorrectionCause"
						data-vv-as="Opis szczegółowy"
						label="Opis szczegółowy"
						aria-label="detailed correction cause"
						for="agency-project-evaluation-sublist-details"
						id="agency-project-evaluation-sublist-details"
						v-model="detailedCorrectionCause"
						:error-messages="vErrors.collect('detailedCorrectionCause')"
						v-validate="'required'">
					</v-textarea>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						v-if="correctionCause !== '' && detailedCorrectionCause !== ''"
						color="blue darken-1"
						flat
						@click="sendForCorrection">
						Wyślij
					</v-btn>
					<v-btn
						color="blue"
						@click="correctionData.dialog = false">
						Anuluj
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

	</v-list>
</template>
<script>
	import EgrantyIconButton from "../../../../genericComponents/EgrantyIconButton";
	import {AgencyExpertEvaluation} from "@/api/generated/AgencyExpertEvaluation";
	import {AgencyFinalEvaluation} from "@/api/generated/AgencyFinalEvaluation";
	import {AgencySubstantiveEvaluation} from "@/api/generated/AgencySubstantiveEvaluation";
	import {Api} from "@/api";

	export default {
		name: "AgencyProjectEvaluationSublist",

		components: {EgrantyIconButton},

		data () {
			return {
				correctionData: {
					dialog: false,
					type: '',
					evaluation: {}
				},
				correctionCause: '',
				detailedCorrectionCause: ''
			};
		},

		props: {
			project: {
				type: Object, default: () => {
				}
			},
			evaluationOpen: {
				type: Boolean, default: false
			}
		},

		watch: {
			"correctionData.dialog": function (val) {
				if (!val) {
					this.correctionCause = '';
					this.detailedCorrectionCause = '';
				}
			}
		},

		methods: {
			onKeyDownEvent (evt) {
				if (this.correctionCause.length >= 255 && evt.keyCode >= 48 && evt.keyCode <= 90) evt.preventDefault();
			},

      evaluationManagementDisabled() {
        return !this.evaluationOpen;
      },

			deleteSubstantiveEvaluation (project, evaluationId, index) {
				this.$confirm("Czy na pewno chcesz usunąć opinię merytoryczną?", {
					icon: 'delete',
					title: 'Usunięcie opinii merytorycznej',
					color: 'lightred',
					width: 500
				})
					.then(response => {
						if (response) {
							AgencySubstantiveEvaluation.delete(this, evaluationId,
								successResponse => {
									this.$emit("substantive-evaluation-removed", project.id, index);
									this.$messagesBus.$emit("success", "Pomyślnie usunięto ocenę", successResponse);
								},
								errorResponse => {
									this.$messagesBus.$emit("error", "Nie udało się usunąć oceny", errorResponse);
								});
						}
					});
			},

			deleteFinalEvaluation (project) {
				this.$confirm("Czy na pewno chcesz usunąć ocenę końcową?", {
					icon: 'delete',
					title: 'Usunięcie oceny końcowej',
					color: 'lightred',
					width: 500
				})
					.then(response => {
						if (response) {
							AgencyFinalEvaluation.delete(this, project.finalEvaluation.id,
								successResponse => {
									this.$emit("final-evaluation-removed", project.id);
									this.$messagesBus.$emit("success", "Pomyślnie usunięto ocenę", successResponse);
								},
								errorResponse => {
									this.$messagesBus.$emit("error", "Nie udało się usunąć oceny", errorResponse);
								});
						}
					});
			},

			deleteExpertEvaluation (project, evaluationId, index) {
				this.$confirm("Czy na pewno chcesz usunąć opinię eksperta?", {
					icon: 'delete',
					title: 'Usunięcie opinii eksperta',
					color: 'lightred',
					width: 500
				})
					.then(response => {
						if (response) {
							AgencyExpertEvaluation.delete(this, evaluationId,
								successResponse => {
									this.$emit("expert-evaluation-removed", project.id, index);
									this.$messagesBus.$emit("success", "Pomyślnie usunięto opinię", successResponse);
								},
								errorResponse => {
									this.$messagesBus.$emit("error", "Nie udało się usunąć opinii", errorResponse);
								});
						}
					});
			},

			getSubstantiveEvaluationStatusText (evaluation) {
				switch (evaluation.agencySubstantiveEvaluationStatus) {
					case "NOT_STARTED":
						return "Nierozpoczęta";
					case "INAPPROPRIATE_ASSIGNMENT":
						return "Niewłaściwie przypisana";
					case "STARTED":
						return "Rozpoczęta";
					case "REVISION":
						return "Do poprawek: " + evaluation.correctionCause;
					case "FINISHED":
						return "Zakończona";
				}
			},

			getFinalEvaluationStatusText (evaluation) {
				switch (evaluation.agencyFinalEvaluationStatus) {
					case "NOT_STARTED":
						return "Nierozpoczęta";
					case "INAPPROPRIATE_ASSIGNMENT":
						return "Niewłaściwie przypisana";
					case "STARTED":
						return "Rozpoczęta";
					case "REVISION":
						return "Do poprawek: " + evaluation.correctionCause;
					case "FINISHED":
						return "Zakończona";
				}
			},

			getExpertEvaluationStatusText (evaluation) {
				switch (evaluation.agencyExpertEvaluationStatus) {
					case "NOT_STARTED":
						return "Nierozpoczęta";
					case "INAPPROPRIATE_ASSIGNMENT":
						return "Niewłaściwie przypisana";
					case "STARTED":
						return "Rozpoczęta";
					case "REVISION":
						return "Do poprawek: " + evaluation.correctionCause;
					case "FINISHED":
						return "Zakończona";
				}
			},

			viewEvaluation (type, evaluation) {
				let suffix = "/" + type + "-evaluation/" + evaluation.id;
				this.$router.push("/app/agency-contest/".concat(this.$route.params.id).concat(suffix));
			},

			correctEvaluation (type, evaluation) {
				this.correctionData.type = type;
				this.correctionData.evaluation = evaluation;
				this.correctionData.dialog = true;
			},

			sendForCorrection () {
				Api.put(this, "/agency-" + this.correctionData.type + "-evaluation/correction?evaluationId=" + this.correctionData.evaluation.id, {
          correctionCause: this.correctionCause,
          detailedCorrectionCause: this.detailedCorrectionCause,
        }, successResponse => {
					switch (this.correctionData.type) {
						case "substantive":
							this.correctionData.evaluation.agencySubstantiveEvaluationStatus = "REVISION";
							break;
						case "final":
							this.correctionData.evaluation.agencyFinalEvaluationStatus = "REVISION";
							break;
						case "expert":
							this.correctionData.evaluation.agencyExpertEvaluationStatus = "REVISION";
							break;
					}
					this.correctionData.evaluation.correctionCause = this.correctionCause;
					this.correctionData.evaluation.detailedCorrectionCause = this.detailedCorrectionCause;
					this.correctionData.dialog = false;
					this.$emit("update-warning-codes");
					this.$messagesBus.$emit("success", "Ocena została odesłana do poprawek", successResponse);
				}, errorResponse => {
					this.$messagesBus.$emit("error", "Nie udało się odesłać oceny do poprawek", errorResponse);
				});
			}
		},
	};
</script>
